import {FeatureFlag} from './feature-flag.model';

export class FeatureFlags {
    flags: Array<FeatureFlag>;
  
    constructor() {
        this.flags = new Array<FeatureFlag>();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/featureflags/feature-flags.model.ts